import React from 'react';
import { ReportPinnedIcon } from 'components/common/svg';

// eslint-disable-next-line import/prefer-default-export
export const FilledReportPinnedIcon = () => (
  <ReportPinnedIcon fill="var(--primaryColor)" width={20} height={20} />
);
